/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { map } from 'lodash'
import { useSelector } from 'react-redux';
import { useState } from 'react';
import SwitchR from "react-switch";
function AntecedentesHeredoFamiliares(){
    const { catalogos } = useSelector((state) => state.solicitud);
  
const [chkProblemasAudMadre, setchkProblemasAudMadre] = useState(false);
const [chkEnfNeoplasicasMadre, setchkEnfNeoplasicasMadre] = useState(false);
const [chkEnfMetabolicasMadre, setchkEnfMetabolicasMadre] = useState(false);
const [chkProbRenalesMadre, setchkProbRenalesMadre] = useState(false);
const [chkEnfCardioMadre, setchkEnfCardioMadre] = useState(false);
const [chkEnfPsiqMadre, setchkEnfPsiqMadre] = useState(false);
const [chkProbNingunaMadre, setchkProbNingunaMadre] = useState(false);
const [txtOtrasHeredoMadre, settxtOtrasHeredoMadre] = useState("");
const [chkProblemasAudPadre, setchkProblemasAudPadre] = useState(false);
const [chkEnfNeoplasicasPadre, setchkEnfNeoplasicasPadre] = useState(false);
const [chkEnfMetabolicasPadre, setchkEnfMetabolicasPadre] = useState(false);
const [chkProbRenalesPadre, setchkProbRenalesPadre] = useState(false);
const [chkEnfCardioPadre, setchkEnfCardioPadre] = useState(false);
const [chkEnfPsiqPadre, setchkEnfPsiqPadre] = useState(false);
const [chkProbNingunaPadre, setchkProbNingunaPadre] = useState(false);
const [txtOtrasHeredoPadre, settxtOtrasHeredoPadre] = useState("");
const [chkProblemasAudHermanos, setchkProblemasAudHermanos] = useState(false);
const [chkEnfNeoplasicasHermanos, setchkEnfNeoplasicasHermanos] = useState(false);
const [chkEnfMetabolicasHermanos, setchkEnfMetabolicasHermanos] = useState(false);
const [chkProbRenalesHermanos, setchkProbRenalesHermanos] = useState(false);
const [chkEnfCardioHermanos, setchkEnfCardioHermanos] = useState(false);
const [chkEnfPsiqHermanos, setchkEnfPsiqHermanos] = useState(false);
const [chkProbNingunaHermanos, setchkProbNingunaHermanos] = useState(false);
const [txtOtrasHeredoHermanos, settxtOtrasHeredoHermanos] = useState("");
const [txtFamiliarHeredofamiliares, settxtFamiliarHeredofamiliares] = useState("");
const [chkProblemasAudFamiliar, setchkProblemasAudFamiliar] = useState(false);
const [chkEnfNeoplasicasFamiliar, setchkEnfNeoplasicasFamiliar] = useState(false);
const [chkEnfMetabolicasFamiliar, setchkEnfMetabolicasFamiliar] = useState(false);
const [chkProbRenalesFamiliar, setchkProbRenalesFamiliar] = useState(false);
const [chkEnfCardioFamiliar, setchkEnfCardioFamiliar] = useState(false);
const [chkEnfPsiqFamiliar, setchkEnfPsiqFamiliar] = useState(false);
const [txtOtrasHeredoFamiliar, settxtOtrasHeredoFamiliar] = useState("");


    return <>
<Grid container spacing={2}>
    {/* Primera columna: Label */}
    <Grid item xs={12} md={3} lg={2}>
        <MDBox textAlign="right">
            <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
                Enfermedades de la madre:
            </MDTypography>
        </MDBox>
    </Grid>

    {/* Segunda fila: 3 columnas con SwitchR */}
    <Grid item xs={12} md={10} lg={10}>
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProblemasAudMadre(!chkProblemasAudMadre)}
                        checked={chkProblemasAudMadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Auditivas
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfNeoplasicasMadre(!chkEnfNeoplasicasMadre)}
                        checked={chkEnfNeoplasicasMadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Neoplásicas (Cáncer)
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfMetabolicasMadre(!chkEnfMetabolicasMadre)}
                        checked={chkEnfMetabolicasMadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Metabólicas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>

        {/* Tercera fila: 3 columnas con SwitchR */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProbRenalesMadre(!chkProbRenalesMadre)}
                        checked={chkProbRenalesMadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Renales
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfCardioMadre(!chkEnfCardioMadre)}
                        checked={chkEnfCardioMadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Cardiovasculares
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfPsiqMadre(!chkEnfPsiqMadre)}
                        checked={chkEnfPsiqMadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Psiquiátricas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>

        {/* Cuarta fila: SwitchR para Ninguna */}
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProbNingunaMadre(!chkProbNingunaMadre)}
                        checked={chkProbNingunaMadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Ninguna
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>
<br/>
        {/* Quinta fila: TextArea ocupando 3 columnas */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
                <TextField
                    label="Otras"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={txtOtrasHeredoMadre}
                    onChange={(e) => settxtOtrasHeredoMadre(e.target.value)}
                    fullWidth
                />
            </Grid>
        </Grid>
    </Grid>
</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label */}
    <Grid item xs={12} md={2} lg={2}>
        <MDBox textAlign="right">
            <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
                Enfermedades del padre:
            </MDTypography>
        </MDBox>
    </Grid>

    {/* Segunda fila: 3 columnas con SwitchR */}
    <Grid item xs={12} md={10} lg={10}>
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProblemasAudPadre(!chkProblemasAudPadre)}
                        checked={chkProblemasAudPadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Auditivas
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfNeoplasicasPadre(!chkEnfNeoplasicasPadre)}
                        checked={chkEnfNeoplasicasPadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Neoplásicas (Cáncer)
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfMetabolicasPadre(!chkEnfMetabolicasPadre)}
                        checked={chkEnfMetabolicasPadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Metabólicas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>

        {/* Tercera fila: 3 columnas con SwitchR */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProbRenalesPadre(!chkProbRenalesPadre)}
                        checked={chkProbRenalesPadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Renales
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfCardioPadre(!chkEnfCardioPadre)}
                        checked={chkEnfCardioPadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Cardiovasculares
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfPsiqPadre(!chkEnfPsiqPadre)}
                        checked={chkEnfPsiqPadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Psiquiátricas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>

        {/* Cuarta fila: SwitchR para Ninguna */}
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProbNingunaPadre(!chkProbNingunaPadre)}
                        checked={chkProbNingunaPadre}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Ninguna
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>
<br/>
        {/* Quinta fila: TextArea ocupando 3 columnas */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
                <TextField
                    label="Otras"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={txtOtrasHeredoPadre}
                    onChange={(e) => settxtOtrasHeredoPadre(e.target.value)}
                    fullWidth
                />
            </Grid>
        </Grid>
    </Grid>
</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label */}
    <Grid item xs={12} md={2} lg={2}>
        <MDBox textAlign="right">
            <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
                Enfermedades de hermanos:
            </MDTypography>
        </MDBox>
    </Grid>

    {/* Segunda fila: 3 columnas con SwitchR */}
    <Grid item xs={12} md={10} lg={10}>
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProblemasAudHermanos(!chkProblemasAudHermanos)}
                        checked={chkProblemasAudHermanos}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Auditivas
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfNeoplasicasHermanos(!chkEnfNeoplasicasHermanos)}
                        checked={chkEnfNeoplasicasHermanos}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Neoplásicas (Cáncer)
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfMetabolicasHermanos(!chkEnfMetabolicasHermanos)}
                        checked={chkEnfMetabolicasHermanos}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Metabólicas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>

        {/* Tercera fila: 3 columnas con SwitchR */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProbRenalesHermanos(!chkProbRenalesHermanos)}
                        checked={chkProbRenalesHermanos}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Renales
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfCardioHermanos(!chkEnfCardioHermanos)}
                        checked={chkEnfCardioHermanos}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Cardiovasculares
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfPsiqHermanos(!chkEnfPsiqHermanos)}
                        checked={chkEnfPsiqHermanos}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Psiquiátricas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>

        {/* Cuarta fila: SwitchR para Ninguna */}
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProbNingunaHermanos(!chkProbNingunaHermanos)}
                        checked={chkProbNingunaHermanos}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Ninguna
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>
<br/>
        {/* Quinta fila: TextArea ocupando 3 columnas */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
                <TextField
                    label="Otras"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={txtOtrasHeredoHermanos}
                    onChange={(e) => settxtOtrasHeredoHermanos(e.target.value)}
                    fullWidth
                />
            </Grid>
        </Grid>
    </Grid>
</Grid>
<br/>
<Grid container spacing={2}>
    {/* Primera columna: Label */}
    <Grid item xs={12} md={2} lg={2}>
        <MDBox textAlign="right">
            <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: 14 }}>
                Enfermedades de otros familiares:
            </MDTypography>
        </MDBox>
    </Grid>

    {/* Primera fila: Input "¿Qué familiar?" ocupando toda la fila */}
    <Grid item xs={12} md={10} lg={10}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    label="¿Qué familiar?"
                    variant="outlined"
                    value={txtFamiliarHeredofamiliares}
                    onChange={(e) => settxtFamiliarHeredofamiliares(e.target.value)}
                    fullWidth
                />
            </Grid>
        </Grid>

        {/* Segunda fila: 3 columnas con SwitchR */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProblemasAudFamiliar(!chkProblemasAudFamiliar)}
                        checked={chkProblemasAudFamiliar}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Auditivas
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfNeoplasicasFamiliar(!chkEnfNeoplasicasFamiliar)}
                        checked={chkEnfNeoplasicasFamiliar}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Neoplásicas (Cáncer)
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfMetabolicasFamiliar(!chkEnfMetabolicasFamiliar)}
                        checked={chkEnfMetabolicasFamiliar}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Metabólicas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>

        {/* Tercera fila: 3 columnas con SwitchR */}
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkProbRenalesFamiliar(!chkProbRenalesFamiliar)}
                        checked={chkProbRenalesFamiliar}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Renales
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfCardioFamiliar(!chkEnfCardioFamiliar)}
                        checked={chkEnfCardioFamiliar}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Cardiovasculares
                    </MDTypography>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <MDBox display="flex" alignItems="center">
                    <SwitchR
                        disabled={false}
                        onChange={() => setchkEnfPsiqFamiliar(!chkEnfPsiqFamiliar)}
                        checked={chkEnfPsiqFamiliar}
                        height={20}
                        width={50}
                        handleDiameter={18}
                        onColor="#605CA9"
                    />
                    <MDTypography variant="body2" color="white" style={{ marginLeft: 10 }}>
                        Psiquiátricas
                    </MDTypography>
                </MDBox>
            </Grid>
        </Grid>
<br/>
        {/* Cuarta fila: TextArea ocupando toda la fila */}
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    label="Otras"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={txtOtrasHeredoFamiliar}
                    onChange={(e) => settxtOtrasHeredoFamiliar(e.target.value)}
                    fullWidth
                />
            </Grid>
        </Grid>
    </Grid>
</Grid>
    </>
}

export default AntecedentesHeredoFamiliares;